/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Qc_Fix_Uncorrected_ToastInputs */



/**
* | output |
* | --- |
* | "{count} event(s) could not be corrected automatically and need manual review" |
*
* @param {Qc_Fix_Uncorrected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_uncorrected_toast = /** @type {((inputs: Qc_Fix_Uncorrected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Uncorrected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} événement(s) n'ont pas pu être corrigés automatiquement et nécessitent une vérification manuelle`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Event(s) konnten nicht automatisch korrigiert werden und müssen manuell überprüft werden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} eventi non sono stati corretti automaticamente e richiedono una revisione manuale`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} событий не удалось исправить автоматически, требуется ручная проверка`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} evento(s) no se pudieron corregir automáticamente y requieren revisión manual`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 个事件无法自动修复，需要手动检查`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count}件のイベントを自動修正できませんでした。手動で確認してください`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} इवेंट स्वचालित रूप से ठीक नहीं किए जा सके, मैन्युअल समीक्षा आवश्यक है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} evento(s) não puderam ser corrigidos automaticamente e requerem revisão manual`)
	return /** @type {LocalizedString} */ (`${i?.count} event(s) could not be corrected automatically and need manual review`)
});